(function () {
  let simonPlusUser = null;
  let inFlight = false;
  let queue = [];

  function runRequest() {
    return window.simonPlus.get('/users');
  }

  window.getSimonPlusUser = function (onSuccess, onError) {
    if (simonPlusUser) {
      onSuccess(simonPlusUser);
      return;
    }

    if (inFlight) {
      queue.push({ onSuccess, onError });
      return;
    }

    inFlight = true;

    runRequest()
      .then(data => {
        simonPlusUser = data.jsonBody;
        inFlight = false;

        queue.forEach(cb => cb.onSuccess?.(simonPlusUser));
        queue = [];

        onSuccess(simonPlusUser);
      })
      .catch(error => {
        inFlight = false;

        queue.forEach(cb => cb.onError?.(error));
        queue = [];

        onError?.(error);
      });
  };
})();